<template>
  <div v-if="displayCategories.length" class="object-categories-readonly">
    <div class="object-categories-readonly__grid">
      <article
        v-for="category in displayCategories"
        :key="category.id"
        class="object-categories-readonly__card"
      >
        <p class="object-categories-readonly__card-path">
          {{ category.path }}
        </p>
      </article>
    </div>

    <FieldArray v-if="hasCategoriesData" name="categories_data" v-slot="{ fields }">
      <template v-for="field in fields" :key="`hidden-${field.key}`">
        <Field :name="`categories_data[${field.key}].id`" type="hidden" />
        <Field :name="`categories_data[${field.key}].checked`" type="hidden" />
      </template>
    </FieldArray>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { Field, FieldArray, useFormValues } from 'vee-validate'
import { useCategoryStore } from '@/stores/category'
import { BASE_TYPES } from '@/stores/constants'
import { resolveBaseTypeKey } from '@/utils/baseTypeTheme'
import { assignedCategoriesFromObject, categoryDisplayPath } from '@/utils/objectCategories'

export default {
  components: {
    Field,
    FieldArray,
  },
  props: {
    baseType: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const formValues = useFormValues()
    const route = useRoute()
    const categoryStore = useCategoryStore()
    const catalog = ref([])

    const baseTypeFilter = computed(() => {
      const key = resolveBaseTypeKey(props.baseType || route.name)
      return BASE_TYPES[key] || null
    })

    onMounted(() => {
      const params = baseTypeFilter.value ? { base_type: baseTypeFilter.value } : {}
      categoryStore.index(params).then(({ data }) => {
        catalog.value = Array.isArray(data) ? data : data?.categories || []
      })
    })

    const hasCategoriesData = computed(() => Array.isArray(formValues.value?.categories_data))

    const displayCategories = computed(() => assignedCategoriesFromObject(formValues.value || {})
      .map((category) => ({
        id: category.id,
        path: categoryDisplayPath(category, catalog.value),
      }))
      .filter((category) => category.path))

    return {
      displayCategories,
      hasCategoriesData,
    }
  },
}
</script>

<style scoped lang="scss">
.object-categories-readonly {
  margin-top: 0;
  margin-bottom: 1.5rem;
}

.object-categories-readonly__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
}

.object-categories-readonly__card {
  width: 100%;
  padding: 0.95rem 1rem;
  border: 1px solid color-mix(in srgb, var(--base-type-primary) 16%, #ffffff);
  border-left: 0.28rem solid var(--base-type-primary);
  background: #fff;
  box-shadow: 0 0.45rem 1rem rgba(10, 33, 48, 0.05);
}

.object-categories-readonly__card-path {
  margin: 0;
  color: var(--base-type-text);
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.45;
}
</style>
